<!-- Modal -->
<div
  class="modal fade"
  id="nuevoPlanModal"
  tabindex="-1"
  aria-labelledby="nuevoPlanModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="nuevoPlanModalLabel">
          {{ modoEditar === true ? "Editar Plan" : "Nuevo Plan" }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="modoEditar ? actualizarPlan() : agregarPlan()">
          <div class="row">
            <div class="col-md-4 mb-4 d-none">
              <input
                type="text"
                class="form-control"
                id="id"
                [(ngModel)]="nuevoPlan.id"
                name="id"
                required
              />
            </div>
            <div class="col-md-4 mb-4">
              <label for="descripcion" class="form-label">Descripcion</label>
              <input
                type="text"
                class="form-control"
                id="descripcion"
                [(ngModel)]="nuevoPlan.descripcion"
                name="descripcion"
                required
              />
              <div *ngIf="errores['descripcion']" class="text-danger">
                {{ errores["descripcion"] }}
              </div>
            </div>
            <div class="col-md-4 mb-4">
              <label for="importeDesde" class="form-label">Importe Desde</label>
              <input
                type="text"
                class="form-control"
                id="importeDesde"
                [(ngModel)]="nuevoPlan.importeDesde"
                name="importeDesde"
                required
              />
              <div *ngIf="errores['importeDesde']" class="text-danger">
                {{ errores["importeDesde"] }}
              </div>
            </div>
            <div class="col-md-4 mb-4">
              <label for="importeHasta" class="form-label">Importe Hasta</label>
              <input
                type="text"
                class="form-control"
                id="importeHasta"
                [(ngModel)]="nuevoPlan.importeHasta"
                name="importeHasta"
                required
              />
              <div *ngIf="errores['importeHasta']" class="text-danger">
                {{ errores["importeHasta"] }}
              </div>
            </div>
            <div *ngIf="modoEditar === true" class="col-md-4 mb-4">
              <label for="activo" class="form-label">Activo</label>
              <input
                type="checkbox"
                class="form-check-input"
                id="activo"
                [(ngModel)]="nuevoPlan.activo"
                name="activo"
              />
            </div>
          </div>
          <button type="submit" class="btn btn-primary" id="guardarEdicion">
            Guardar Plan
          </button>
          <button
            id="eliminarPlan"
            *ngIf="modoEditar === true"
            type="button"
            class="btn btn-danger ms-2"
            (click)="eliminarPlan(nuevoPlan.id)"
          >
            Eliminar Plan
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
